import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { ErrorText } from '@/components/ui';
import { authClient, authErrorMessage } from '@/lib/auth-client';
import { useMe } from '@/lib/queries';
import { AuthLayout } from './AuthLayout';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const me = useMe();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const res = await authClient.requestPasswordReset({
      email,
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setBusy(false);
    if (res.error) return setError(authErrorMessage(res.error));
    setSent(true);
  };

  return (
    <AuthLayout title="Reset your password." sub="We'll email you a link that works for one hour.">
      {sent ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            fontSize: 14,
            lineHeight: 1.5,
            color: '#333',
          }}
        >
          <div>
            If <b>{email}</b> has an account, a reset link is on its way.
          </div>
          {me.data?.features.devMailbox && (
            <div className="muted" style={{ fontSize: 12.5 }} data-testid="mailbox-note">
              Test environment: every email sent here also lands in the{' '}
              <Link to="/mailbox">mailbox</Link>. Open it to grab the link if it is not in your
              inbox.
            </div>
          )}
          <Link to="/login" style={{ fontSize: 13, fontWeight: 600 }}>
            ← Back to log in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} style={{ display: 'contents' }}>
          <input
            className="input"
            type="email"
            placeholder="Email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            aria-label="Email"
            required
          />
          <ErrorText>{error}</ErrorText>
          <button type="submit" className="btn btn-primary btn-lg hv" disabled={busy}>
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
          <Link to="/login" style={{ fontSize: 12.5, color: '#777' }}>
            ← Back to log in
          </Link>
        </form>
      )}
    </AuthLayout>
  );
}
